/* eslint-disable */
import React, { PropTypes } from 'react'
import _ from 'lodash';
import $ from 'jquery';
import { Panel, Button, Col, Row, Well } from 'react-bootstrap';
import { TextField, TextAreaField } from './AdminComponents';
import Dropzone from 'react-dropzone';
// import { DataListWrapper, SortTypes, SortHeaderCell, TextCell, NewsTypeCell, TimeWithoutHHmmssCell } from "../../../commonComponents/DataTable/DataTablePs";
// import custJqAjax from '../../../commonJS/custJqAjax';

export default class AdminUserCompanyInfo extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      is_loading: true,
      company_name: '',
      company_title: '',
      company_content: '',
      company_logo: '',
      company_logo_file: [],
      company_image: '',
      company_image_file: [],
      company_video: {},
      company_video_file: [],
    }

    this.onChangeHandler = this.onChangeHandler.bind(this);

  }

  componentDidMount() {

    this.loadData();
  }

  componentWillReceiveProps(nextProps) {


  }

  componentDidUpdate(prevProps, prevState) {


  }

  loadData() {

    $.ajax({
      type: 'get',
      url: '/api/W_UserCompanyInfo_Get.php',
      success: response => {
        this.setState({
          company_name: response.result.company_name,
          company_title: response.result.title,
          company_content: response.result.content,
          company_logo: response.result.logo,
          company_image: response.result.image,
          company_video: response.result.video,
          is_loading: false
        });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onChangeHandler(stateName, event) {
    let newState = {};
    newState[stateName] = event.target.value;
    this.setState(newState);
  }

  onDrop(type, acceptedFiles) {
    if (acceptedFiles.length > 1) {

      alert('請上傳單一檔案')
      return false
    }

    let file_type = acceptedFiles[0].type.split('/')

    switch (type) {

      case 'logo':
        if (file_type[0] !== 'image') {
          alert('檔案格式不符')
          return false
        }
        this.setState({ company_logo_file: acceptedFiles });
        this.refs.company_logo.style.display = 'none'
        break;
      case 'image':
        if (file_type[0] !== 'image') {
          alert('檔案格式不符')
          return false
        }
        this.setState({ company_image_file: acceptedFiles });
        this.refs.company_img.style.display = 'none'
        break;
      case 'video':
        if (file_type[0] !== 'video') {
          alert('檔案格式不符')
          return false
        }
        this.setState({ company_video_file: acceptedFiles });
        this.refs.company_video.style.display = 'none'
        break;
    }
  }

  onOpenClick(type) {

    switch (type) {

      case 'logo':
        this.dropzone_logo.open();
        break;
      case 'image':
        this.dropzone_image.open();
        break;
      case 'video':
        this.dropzone_video.open();
        break;
    }
  }

  onSubmit() {

    this.refs.loading.style.display = 'flex'
    const { company_name, company_title, company_content } = this.state

    let formData = new FormData();
    formData.append('company_name', company_name);
    formData.append('title', company_title);
    formData.append('content', company_content);
    // formData.append( 'file', company_image_file );
    // formData.append( 'image', company_image );
    // formData.append( 'video', company_video );

    $.ajax({
      type: 'post',
      url: '/api/W_UserCompanyInfo_Update.php',
      data: formData,
      processData: false,
      contentType: false,
      success: response => {
        this.uploadFile()
        response.status === "0" ? alert('儲存成功') : alert(response.msg)
        // this.refs.loading.style.display = 'none'
      },
      error: (xhr, ajaxOptions, thrownError) => { },
      complete: () => {
        this.refs.loading.style.display = 'none'
      }
    });
  }

  uploadFile() {
    const { company_image_file, company_video_file, company_logo_file } = this.state

    if (company_logo_file.length !== 0) {

      let formData = new FormData();
      formData.append('file', company_logo_file[0]);
      formData.append('type', 'CompanyLogo_Local');

      $.ajax({
        async: false,
        type: 'post',
        url: '/api/W_SaleSky_FileUpload_Post.php',
        data: formData,
        processData: false,
        contentType: false,
        success: response => { },
        error: error => { },
      });
    }

    if (company_image_file.length !== 0) {

      let formData = new FormData();
      formData.append('file', company_image_file[0]);
      formData.append('type', 'CompanyIntroductionImage_Local');

      $.ajax({
        async: false,
        type: 'post',
        url: '/api/W_SaleSky_FileUpload_Post.php',
        data: formData,
        processData: false,
        contentType: false,
        success: response => { },
        error: error => { },
      });
    }

    if (company_video_file.length !== 0) {

      let formData = new FormData();
      formData.append('file', company_video_file[0]);
      formData.append('type', 'CompanyIntroductionVideo_Local');

      $.ajax({
        async: false,
        type: 'post',
        url: '/api/W_SaleSky_FileUpload_Post.php',
        data: formData,
        processData: false,
        contentType: false,
        success: response => { },
        error: error => { },
      });
    }
  }

  render() {
    const {
      is_loading,
      company_name,
      company_title,
      company_content,
      company_logo,
      company_logo_file,
      company_image,
      company_image_file,
      company_video,
      company_video_file
    } = this.state
    // const loading = is_loading === true ?  : false

    return (
      <div style={{ position: "relative" }}>
        {<div ref="loading" className="loading" style={{ display: is_loading === true ? 'flex' : 'none' }}><img role="presentation" src="/imgs/loading.gif" /></div>}
        <Panel header={<h3>公司簡介</h3>}>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: 'none' }}>* </span>公司名稱</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                {
                  /*
                  <TextField 
                    fieldName='company_name'
                    fieldValue={company_name}
                    onChangeHandler={this.onChangeHandler}
                  />
                  */
                }
                <div>{company_name}</div>
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>公司簡介抬頭</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <TextField
                  fieldName='company_title'
                  fieldValue={company_title}
                  onChangeHandler={this.onChangeHandler}
                />
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>公司簡介內容</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <TextAreaField
                  fieldName='company_content'
                  fieldValue={company_content}
                  onChangeHandler={this.onChangeHandler}
                />
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: 'none' }}>* </span>公司Logo</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <div ref="company_logo"><img src={company_logo} style={{ width: '100%', maxWidth: '640px' }} role="presentation" /></div>
                {company_logo_file.length > 0 ? <div style={{ marginTop: '20px' }}>{company_logo_file.map((file, y) => <img key={'logo' + y} style={{ width: '100%', maxWidth: '640px' }} src={file.preview} />)}</div> : null}
                <Dropzone ref={(node) => { this.dropzone_logo = node; }} onDrop={this.onDrop.bind(this, 'logo')} style={{ display: 'none' }} />
                <Button style={{ marginTop: '20px' }} onClick={() => this.onOpenClick('logo')}>上傳檔案</Button>
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: 'none' }}>* </span>公司簡介圖片</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <div ref="company_img"><img src={company_image} style={{ width: '100%', maxWidth: '640px' }} role="presentation" /></div>
                {company_image_file.length > 0 ? <div style={{ marginTop: '20px' }}>{company_image_file.map((file, y) => <img key={'logo' + y} style={{ width: '100%', maxWidth: '640px' }} src={file.preview} />)}</div> : null}
                <Dropzone ref={(node) => { this.dropzone_image = node; }} onDrop={this.onDrop.bind(this, 'image')} style={{ display: 'none' }} />
                <Button style={{ marginTop: '20px' }} onClick={() => this.onOpenClick('image')}>上傳檔案</Button>
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}><span style={{ color: "red", display: 'none' }}>* </span>公司簡介影片</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <div ref="company_video"><video controls src={company_video.file_name} style={{ width: '100%', maxWidth: '640px' }} /></div>
                {company_video_file.length > 0 ? <div style={{ marginTop: '20px' }}>{company_video_file.map((file, y) => <video controls key={'logo' + y} style={{ width: '100%', maxWidth: '640px' }} src={file.preview} />)}</div> : null}
                <Dropzone ref={(node) => { this.dropzone_video = node; }} onDrop={this.onDrop.bind(this, 'video')} style={{ display: 'none' }} />
                <Button style={{ marginTop: '20px' }} onClick={() => this.onOpenClick('video')}>上傳檔案</Button>
              </Well>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Button onClick={() => this.onSubmit()}>儲存</Button>
            </Col>
          </Row>
        </Panel>
      </div>
    )
  }
}

AdminUserCompanyInfo.PropTypes = {
  filteredDataList: PropTypes.object.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminUserCompanyInfo.jsx